// extracted by mini-css-extract-plugin
export var btn = "banner-module--btn--lxTLG";
export var btnBlock = "banner-module--btnBlock--ibpja";
export var container = "banner-module--container--U+my3";
export var hideMobBlock = "banner-module--hideMobBlock--Y++wm";
export var img = "banner-module--img--Cny10";
export var mobBtn = "banner-module--mobBtn--Z+1P+";
export var secondContainer = "banner-module--secondContainer--1VU4S";
export var section = "banner-module--section--3zwvQ";
export var text = "banner-module--text--v2D7L";